import axios from 'axios'

const http = axios.create({
	// baseURL: '/api',
	//timeout: 6000,
	withCredentials: true,
	headers: {
		'Content-Type':' application/json',
		'X-Requested-With': 'XMLHttpRequest'
	},
});
http.interceptors.request.use((config) => {
	// 在发送请求之前做些什么
	let token=localStorage.getItem('token');
	if(token === undefined || token === null){
		config.headers.token='';
	}else{
		config.headers.token=token;
	}
	return config
}, function (error) {
	// 对请求错误做些什么
	return Promise.reject(error)
});
export default http



// WEBPACK FOOTER //
// ./src/axios/index.js